<template>
  <div class="page-header-relate mb-4">
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
      <div>
        <div v-if="badgeText || $slots.badge" class="d-flex align-items-center gap-2 mb-1.5">
          <slot name="badge">
            <span class="badge-relate">
              <span class="status-dot" :class="statusDotClass"></span>
              {{ badgeText }}
            </span>
          </slot>
        </div>
        <h1 class="page-header-title mb-1">
          {{ title }}
        </h1>
        <p v-if="subtitle" class="page-header-subtitle mb-0">
          {{ subtitle }}
        </p>
      </div>

      <div v-if="$slots.actions" class="d-flex align-items-center gap-2 flex-wrap">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    badgeText: {
      type: String,
      default: ''
    },
    badgeType: {
      type: String,
      default: 'blue' // 'blue', 'green', 'azure', 'red'
    }
  },
  computed: {
    statusDotClass() {
      return `status-dot-${this.badgeType}`
    }
  }
}
</script>

<style scoped>
.page-header-relate {
  padding: 4px 0 8px 0;
}

.page-header-title {
  font-family: var(--font-inter);
  font-size: 24px;
  font-weight: 700;
  color: var(--color-midnight-ink);
  letter-spacing: -0.03em;
  line-height: 1.25;
}

.page-header-subtitle {
  font-size: 13.5px;
  color: var(--color-ash-helper);
  line-height: 1.45;
  max-width: 680px;
}

@media (max-width: 768px) {
  .page-header-title {
    font-size: 20px;
  }
}
</style>
